import { jsx as e } from "react/jsx-runtime";
import { d as s, aA as l } from "../../vendor-Dd6qj6gJ.js";
import { Avatar as r } from "../Avatar/index.js";
import { BaseIcon as i } from "../BaseIcon/index.js";
import { Icon as a } from "../Icon/index.js";
import { Hotkey as m } from "../Hotkey/index.js";
import { Pill as d } from "../Pill/index.js";
import '../../assets/index35.css';const f = "_item_1woxz_1", _ = "_generated_1woxz_38", b = "_selectable_1woxz_47", p = "_decorationLeft_1woxz_56", x = "_decorationRight_1woxz_65", g = "_label_1woxz_73", u = "_description_1woxz_82", c = {
  item: f,
  generated: _,
  selectable: b,
  decorationLeft: p,
  decorationRight: x,
  label: g,
  description: u
};
function h({ as: o, className: n, ...t }) {
  return /* @__PURE__ */ e(o, { ...t, className: s(c.item, n) });
}
const w = ({ avatarProps: o, iconProps: n }) => {
  let t = null;
  return o ? t = /* @__PURE__ */ e(r, { ...o }) : n && (t = /* @__PURE__ */ e(a, { ...n, color: n.color ?? "moon" })), /* @__PURE__ */ e("div", { className: c.decorationLeft, children: t });
}, z = ({ hotkeyProps: o, pillProps: n }) => {
  let t = null;
  return o ? t = /* @__PURE__ */ e(m, { ...o }) : n && (t = /* @__PURE__ */ e(d, { ...n })), /* @__PURE__ */ e("div", { className: c.decorationRight, children: t });
}, R = ({ children: o }) => /* @__PURE__ */ e(l, { elementType: "span", slot: "label", className: c.label, children: o }), N = ({ children: o }) => o ? /* @__PURE__ */ e(l, { elementType: "span", slot: "description", className: c.description, children: o }) : null, A = Object.assign(h, {
  DecorationLeft: w,
  DecorationRight: z,
  Label: R,
  Description: N,
  Selectable: () => /* @__PURE__ */ e("div", { className: s(c.generated, c.selectable), children: /* @__PURE__ */ e(i, { icon: "checkmark2", color: "moon", size: "sm" }) }),
  Submenu: () => /* @__PURE__ */ e("div", { className: c.generated, children: /* @__PURE__ */ e(i, { icon: "chevron-next", color: "moon", size: "sm" }) })
});
export {
  w as DecorationLeft,
  z as DecorationRight,
  N as Description,
  A as ItemRow,
  R as Label
};
